// extracted by mini-css-extract-plugin
export default {"btn":"CommandActionButton_btn__ShVBy","icon":"CommandActionButton_icon__cczYN"};